"use strict";

exports.__esModule = true;
exports["default"] = getTheme;
exports.createTheme = void 0;

var _lodash = require("lodash");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _wixParams = require("../../constants/wix-params");

var _colors = require("../../services/colors");

var _businessManagerTheme = _interopRequireDefault(require("./business-manager-theme"));

var _theme = _interopRequireDefault(require("./theme.scss"));

var _themeOoi = _interopRequireDefault(require("./theme-ooi.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getTheme(_ref) {
  var _classNames, _classNames2, _classNames3, _classNames4, _classNames5, _classNames6, _classNames7, _classNames8;

  var appSettings = _ref.appSettings,
      readOnly = _ref.readOnly,
      isCompact = _ref.isCompact,
      tooltipsEnabled = _ref.tooltipsEnabled,
      isViewer = _ref.isViewer,
      isSeo = _ref.isSeo,
      isMobile = _ref.isMobile,
      richContentFontClassName = _ref.richContentFontClassName,
      useDescriptionFontInEditor = _ref.useDescriptionFontInEditor,
      isPostPage = _ref.isPostPage,
      isOOI = _ref.isOOI,
      version = _ref.version;
  var styles = isOOI ? _themeOoi["default"] : _theme["default"];
  var advancedPostOpts = (0, _lodash.get)(appSettings, _wixParams.IS_POST_ADVANCED_DESIGN_OPTIONS_ENABLED_PATH, false);
  var linkHashtagColor = (0, _colors.getSiteColor)(appSettings, {
    wixParam: isPostPage === false ? _wixParams.POST_HOMEPAGE_LINK_AND_HASHTAG_COLOR : _wixParams.LINK_AND_HASHTAG_COLOR,
    presetFallback: 'color-8',
    colorFallback: '#44C2BC'
  });
  var imageContainerClass = 'image-container';
  var imageCaptionClass = 'image-caption';
  var toolbarButtonWrapperClass = 'rce-toolbar-button-wrapper';
  var toolbarButtonActiveClass = 'rce-toolbar-button-active';
  var blogSharedValues = {
    colors: {
      linkHashtagColor: linkHashtagColor
    },
    classes: {
      imageContainerClass: imageContainerClass,
      imageCaptionClass: imageCaptionClass,
      toolbarButtonWrapperClass: toolbarButtonWrapperClass,
      toolbarButtonActiveClass: toolbarButtonActiveClass
    }
  };
  var defaultToolbarTheme = {
    toolbar: (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor, styles.toolbarShadow),
    toolbarButton_wrapper: (0, _classnames["default"])(toolbarButtonWrapperClass, styles.toolbarButtonWrapper),
    toolbarButton_active: toolbarButtonActiveClass,
    toolbarButton: styles.toolbarButton,
    toolbarButton_icon: (0, _classnames["default"])(styles.textColor, styles.toolbarButtonIcon),
    toolbarSeparator: styles.dividerBackgroundColor,
    toolbar_scrollableContainer: styles.toolbarScrollableContainer
  };
  var headerTwoStyles = advancedPostOpts ? (0, _classnames["default"])('blog-post-header-two-font', 'blog-post-header-two-color', (_classNames = {}, _classNames[styles.mobileHeaderTwoFontSize] = isMobile, _classNames)) : (0, _classnames["default"])('blog-post-title-font', styles.headerTwo, styles.headerTwoFontSize, (_classNames2 = {}, _classNames2[styles.mobileHeaderTwoFontSize] = isMobile, _classNames2));
  var headerThreeStyles = advancedPostOpts ? (0, _classnames["default"])('blog-post-header-three-font', 'blog-post-header-three-color', (_classNames3 = {}, _classNames3[styles.mobileHeaderThreeFontSize] = isMobile, _classNames3)) : (0, _classnames["default"])('blog-post-title-font', styles.headerThree, styles.headerThreeFontSize, (_classNames4 = {}, _classNames4[styles.mobileHeaderThreeFontSize] = isMobile, _classNames4));
  var quoteStyles = advancedPostOpts ? (0, _classnames["default"])(styles.quote, 'blog-post-quote-font', 'blog-post-quote-color', 'blog-quote-border-color', (_classNames5 = {}, _classNames5[styles.mobileQuotesFontSize] = isMobile, _classNames5)) : (0, _classnames["default"])(styles.quote, styles.advancedQuoteStylesOff, 'blog-quote-border-color', (_classNames6 = {}, _classNames6[styles.mobileQuotesFontSize] = isMobile, _classNames6));
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    advancedPostOpts: advancedPostOpts,
    blogSharedValues: blogSharedValues,
    editor: (0, _classnames["default"])(styles.editor, isSeo && styles.seo, useDescriptionFontInEditor ? richContentFontClassName : styles.editorDesktopFontSize, isMobile && styles.mobileFontSize, styles.editorImageCaption),
    wrapper: (0, _classnames["default"])(styles.wrapper, richContentFontClassName, (_classNames7 = {}, _classNames7[styles.readOnly] = readOnly, _classNames7[styles.sizeCompact] = isCompact, _classNames7)),
    overlay: styles.overlay,
    desktop: styles.desktop,
    android: styles.android,
    sizeFullWidth: styles.sizeFullWidth,
    sizeSmall: styles.sizeSmall,
    textWrapNowrap: styles.textWrapNowrap,
    text: (0, _classnames["default"])(styles.text, 'blog-post-text-font', 'blog-post-text-color'),
    quote: quoteStyles,
    headerOne: (0, _classnames["default"])('blog-post-title-font', styles.headerTwo, styles.headerTwoFontSize),
    headerTwo: headerTwoStyles,
    headerThree: headerThreeStyles,
    orderedList: (0, _classnames["default"])(styles.text, styles.listItem, isViewer || version === '6.10.5' ? styles.orderedListItem : undefined),
    orderedListContainer: styles.orderedListContainer,
    unorderedList: (0, _classnames["default"])(styles.text, styles.listItem, styles.unorderedListItem),
    unorderedListContainer: styles.unorderedListContainer,
    atomic: styles.atomic,
    link: (0, _classnames["default"])('blog-link-hashtag-color', styles.link),
    hashtag: (0, _classnames["default"])('blog-link-hashtag-color', styles.hashtag),
    pluginContainer: (0, _classnames["default"])(styles.highlightedBorderColor, styles.pluginContainer, styles.pluginContainerImageCaption),
    panelContainer: (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor, styles.toolbarShadow),
    hasFocus: (0, _classnames["default"])(styles.highlightedBorderColor, styles.hasFocus),
    focused: styles.focused,
    alignLeft: styles.alignLeft,
    alignRight: styles.alignRight,
    alignCenter: styles.alignCenter,
    htmlComponent: isViewer && styles.htmlComponent,
    pluginContainerMobile: isViewer && styles.pluginContainerMobile,
    left: isViewer && (0, _classnames["default"])(styles.left, styles.text),
    center: isViewer && (0, _classnames["default"])(styles.center, styles.text),
    right: isViewer && (0, _classnames["default"])(styles.right, styles.text),
    justify: isViewer && (0, _classnames["default"])(styles.justify, styles.text)
  }, (0, _utils.createToolbarTheme)('inline', _objectSpread(_objectSpread({}, defaultToolbarTheme), {}, {
    toolbar_buttonWrapper: styles.inlineToolbarButtonWrapper
  }))), (0, _utils.createToolbarTheme)('side', _objectSpread(_objectSpread({}, defaultToolbarTheme), {}, {
    toolbar_floatingIcon: styles.toolbarFloatingIcon
  }))), (0, _utils.createToolbarTheme)('plugin', _objectSpread(_objectSpread({}, defaultToolbarTheme), {}, {
    toolbar_inlinePanel: styles.dividerBorderColor
  }))), (0, _utils.createToolbarTheme)('mobile', _objectSpread(_objectSpread({}, defaultToolbarTheme), {}, {
    toolbar_fixed: styles.mobileToolbarFixed,
    toolbar_responsiveArrow: (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor),
    toolbar_responsiveArrowLeft_icon: styles.textBorderColor,
    toolbar_responsiveArrowRight_icon: styles.textBorderColor,
    toolbar_scrollableContainer: styles.mobileToolbar_scrollableContainer
  }))), (0, _utils.createToolbarTheme)('footer', _objectSpread(_objectSpread({}, defaultToolbarTheme), {}, {
    toolbar: (0, _classnames["default"])(styles.footerToolbar, styles.dividerBorderColor)
  }))), {}, {
    inlineToolbarDropdown_options: styles.inlineToolbarDropdownOptions,
    inlineToolbarDropdownButton_icon: styles.inlineToolbarDropdownButtonIcon,
    'Dropdown-root': (0, _classnames["default"])(richContentFontClassName, styles.dropdownRoot),
    'Dropdown-control': (0, _classnames["default"])('blog-text-color', styles.dropdownControl, styles.dropdownControlHover),
    'Dropdown-menu': (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor),
    'Dropdown-arrow': styles.dropdownArrow,
    'Dropdown-option': (0, _classnames["default"])('blog-text-color', styles.dropdownOptionHover),
    tooltip: (0, _classnames["default"])(styles.tooltipHover, styles.tooltip, (_classNames8 = {}, _classNames8[styles.tooltipHidden] = !tooltipsEnabled, _classNames8)),
    tabs_headers: styles.dividerBorderColor,
    tabs_headers_option: styles.tabsHeadersOption,
    tabs_headers_option_selected: styles.highlightedBorderColor,
    tabs_headers_option_label: (0, _classnames["default"])(richContentFontClassName, styles.tabsHeadersOptionLabel),
    button_primary: (0, _classnames["default"])(richContentFontClassName, 'blog-button-background-color', 'blog-button-primary-text-color', styles.button),
    button_secondary: (0, _classnames["default"])(richContentFontClassName, styles.highlightedBorderColor, 'blog-button-secondary-text-color', 'blog-button-secondary-text-hover-color', styles.button, styles.buttonSecondary),
    checkbox_icon: (0, _classnames["default"])(styles.checkboxIcon, styles.highlightedBorderColor, styles.checkboxIcon),
    checkbox_icon_checked: (0, _classnames["default"])(styles.checkboxIconChecked, styles.highlightedBackgroundColor, 'blog-button-primary-text-color'),
    'divider-container': isViewer && styles.dividerContainer,
    gallery_container: isViewer && styles.gallery_container,
    inputWithLabel_input: (0, _classnames["default"])('blog-text-color', styles.dividerBorderColor, styles.focusedInputBorderColor, styles.inputWithLabelInput),
    linkPanel_Content: (0, _classnames["default"])(richContentFontClassName, 'blog-text-color'),
    linkPanel_textInput: (0, _classnames["default"])('blog-text-color', styles.dividerBorderColor, styles.linkPanelTextInputFocus, styles.linkPanelTextInput),
    radioGroup: (0, _classnames["default"])(richContentFontClassName, styles.radioGroup),
    radioGroup_input: styles.radioGroupInput,
    radioGroup_button: (0, _classnames["default"])('blog-button-color', styles.radioGroupButton),
    radioGroupHorizontal_title: (0, _classnames["default"])(richContentFontClassName, styles.radioGroupHorizontalTitle),
    slider: (0, _classnames["default"])('blog-button-color', styles.slider),
    sliderWithInput_label: (0, _classnames["default"])(richContentFontClassName, styles.sliderWithInputLabel),
    sliderWithInput_input: (0, _classnames["default"])(richContentFontClassName, 'blog-text-color', styles.sliderWithInputInput, styles.dividerBorderColor),
    selectionListOption_selected: 'blog-text-color',
    layoutsSelector_label: (0, _classnames["default"])(richContentFontClassName, styles.layoutsSelectorLabel),
    layoutsSelector_tile_label: (0, _classnames["default"])(richContentFontClassName, styles.layoutsSelectorTitleLabel),
    layoutsSelector_icon_selected: styles.highlightedColor,
    thumbnailPlacementSelector_label: (0, _classnames["default"])(richContentFontClassName, styles.thumbnailPlacementSelectorLabel),
    thumbnailPlacementSelector_icon_selected: styles.highlightedColor,
    imageContainer: imageContainerClass,
    video_container: styles.video_container,
    imageRatioSelector_label: (0, _classnames["default"])(richContentFontClassName, styles.imageRatioSelectorLabel),
    imageRatioSelector_ratioLabel: (0, _classnames["default"])(richContentFontClassName, styles.imageRatioSelectorRatioLabel),
    imageRatioSelector_ratioButton: (0, _classnames["default"])('blog-text-after-background-color', styles.imageRatioSelectorRatioButton),
    imageRatioSelector_ratioButton_selected: (0, _classnames["default"])('blog-button-background-color', styles.imageRatioSelectorRatioButtonSelected),
    imageRatioSelector_ratioIcon: (0, _classnames["default"])('blog-text-border-color', styles.imageRatioSelectorRatioIcon),
    imageRatioSelector_ratioIcon_selected: (0, _classnames["default"])('blog-button-primary-text-border-color', styles.imageRatioSelectorRatioIconSelected),
    settingsPanel_footer: (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor),
    section: (0, _classnames["default"])('blog-text-color', richContentFontClassName),
    imageSettings: (0, _classnames["default"])('blog-text-color', styles.imageSettings),
    imageSettingsTitle: (0, _classnames["default"])('blog-post-title-font', styles.imageSettingsTitle),
    imageCaption: imageCaptionClass,
    topBar: (0, _classnames["default"])(richContentFontClassName),
    topBarLink: (0, _classnames["default"])('blog-text-color', 'blog-button-hover-color'),
    filesButton: (0, _classnames["default"])('blog-text-color', 'blog-button-hover-color'),
    filesItem: (0, _classnames["default"])('blog-text-color', styles.dividerBorderColor),
    itemContainer: styles.itemContainer,
    itemContainerSelected: (0, _classnames["default"])('blog-button-color', styles.itemContainerSelected),
    gallerySettings_title: (0, _classnames["default"])('blog-post-title-font', 'blog-text-color', styles.gallerySettingsTitle, styles.opaqueBackgroundColor, styles.dividerBorderColor),
    gallerySettings_divider: styles.dividerBorderColor,
    cameraIcon: 'blog-icon-fill',
    video_modal_container_big: (0, _classnames["default"])(styles.opaqueBackgroundColor),
    video_modal_container_small: (0, _classnames["default"])(styles.opaqueBackgroundColor),
    video_modal_add_a_Video: (0, _classnames["default"])('blog-post-title-font', 'blog-post-title-color', styles.addVideo),
    video_modal_header_text: (0, _classnames["default"])('blog-post-description-font', 'blog-text-color', styles.headerText),
    video_modal_add_button_inline: (0, _classnames["default"])('blog-button-background-color'),
    video_modal_add_button_inMiddle: (0, _classnames["default"])('blog-button-background-color'),
    video_modal_or_upload_video_from: (0, _classnames["default"])('blog-post-description-font', 'blog-text-color', styles.orUploadVideoFrom),
    video_modal_upload_video: (0, _classnames["default"])('blog-post-description-font', 'blog-button-color', 'blog-button-hover-color', styles.orUploadVideoFrom),
    textInput_input: (0, _classnames["default"])('blog-text-color', richContentFontClassName, styles.dividerBorderColor, styles.focusedInputBorderColor, styles.textInputInput),
    galleryImageSettings: (0, _classnames["default"])(styles.galleryImageSettings, richContentFontClassName),
    galleryImageSettings_title: (0, _classnames["default"])(styles.galleryImageSettingsTitle, styles.opaqueBackgroundColor, 'blog-text-color', 'blog-post-title-font'),
    galleryImageSettings_backIcon: 'blog-text-color',
    galleryImageSettings_delete: (0, _classnames["default"])(styles.galleryImageSettingsDelete, 'blog-text-color'),
    galleryImageSettings_replace: 'blog-text-color',
    htmlEditPanel_primaryButton: 'blog-button-color',
    htmlEditPanel_secondaryButton: 'blog-text-color',
    textColorModal: (0, _classnames["default"])(styles.opaqueBackgroundColor, styles.dividerBorderColor),
    textColorModal_mobile: styles.opaqueBackgroundColor,
    colorPicker_separator: styles.colorPickerSeparator,
    colorPicker_add_color_label: 'blog-button-color',
    colorPicker_button: styles.colorPickerButton,
    colorPicker_button_selected: (0, _classnames["default"])(styles.colorPickerButtonSelectedAfter, styles.colorPickerButtonSelected),
    colorPickerDialog_separator: (0, _classnames["default"])(styles.dividerBackgroundColor, styles.colorPickerDialogSeparator),
    colorPickerDialog_buttons: 'blog-post-description-font',
    colorPickerDialog_button: (0, _classnames["default"])(styles.colorPickerDialogButton, 'blog-text-color'),
    colorPickerDialog_button_update: 'blog-button-color',
    customColorPicker_editable_input_container: (0, _classnames["default"])('blog-post-description-font', 'blog-text-color'),
    customColorPicker_input_container: styles.customColorPickerInputContainer,
    customColorPicker_input_label: styles.customColorPickerInputLabel,
    giphy_api_input_modal_container: 'blog-post-description-font',
    giphy_api_input_modal_search_textinput_group: styles.dividerBorderColor,
    giphy_api_input_modal_search: (0, _classnames["default"])('blog-text-color', styles.giphyModalSearchInput),
    giphy_modal_arrow_up: styles.giphyModalArrow,
    giphy_modal_arrow_down: styles.giphyModalArrow,
    overrideDefaultTheme: styles.overrideDefaultTheme,
    overrideAppSettings: styles.overrideAppSettings,
    modal: styles.modal,
    codeBlock: styles.codeBlock,
    file_upload_container: styles.fileUploadContainer,
    file_upload_icon: styles.fileUploadIcon,
    file_upload_name: styles.fileUploadName,
    file_upload_type: styles.fileUploadType,
    file_upload_link: styles.fileUploadLink,
    file_loader_icon: styles.fileLoaderIcon
  });
}

var createTheme = function createTheme(_ref2) {
  var appSettings = _ref2.appSettings,
      readOnly = _ref2.readOnly,
      isCompact = _ref2.isCompact,
      tooltipsEnabled = _ref2.tooltipsEnabled,
      isViewer = _ref2.isViewer,
      isSeo = _ref2.isSeo,
      isOOI = _ref2.isOOI,
      isMobile = _ref2.isMobile,
      richContentFontClassName = _ref2.richContentFontClassName,
      useDescriptionFontInEditor = _ref2.useDescriptionFontInEditor,
      isBusinessManager = _ref2.isBusinessManager,
      css = _ref2.css,
      version = _ref2.version;
  var theme = getTheme({
    appSettings: appSettings,
    readOnly: readOnly,
    isCompact: isCompact,
    tooltipsEnabled: tooltipsEnabled,
    isViewer: isViewer,
    isSeo: isSeo,
    isOOI: isOOI,
    isMobile: isMobile,
    richContentFontClassName: richContentFontClassName,
    useDescriptionFontInEditor: useDescriptionFontInEditor,
    css: css,
    version: version
  });

  if (isBusinessManager) {
    theme = (0, _businessManagerTheme["default"])({
      theme: theme,
      css: css
    });
  }

  return theme;
};

exports.createTheme = createTheme;